import { AxiosResponse } from "axios";
import axiosApiInstance from "src/api/axiosInstance.api";
import {
  IChangeUserPassword,
  IValidateUserAccess,
  IResetUserPassword,
  IUpdateUserPassword,
  IUser,
  IValidateUserOTPSecurity,
  IOTPGenerated,
  IUserIP,
} from "src/models/Maintenance/User.models";
import { IApiResponse } from "src/shared/models/IApiResponse";
import axiosApiInstanceNoToken from "../axiosInstanceNoToken";

export interface IUserSingleApiResponse extends IApiResponse {
  data: IUser;
}

export interface IUserListApiResponse extends IApiResponse {
  data: IUser[];
}
export interface IUserIPSingleApiResponse extends IApiResponse {
  data: IUserIP;
}

export interface IUserIPListApiResponse extends IApiResponse {
  data: IUserIP[];
}

export interface IAnyApiResponse extends IApiResponse {
  data: any;
}

const responseBody = (response: AxiosResponse) => response.data;

const requests = {
  get: (url: string, params?: any) =>
    axiosApiInstance.get(url, { params: params }).then(responseBody),
  post: (url: string, body: {}) =>
    axiosApiInstance.post(url, body).then(responseBody),
  put: (url: string, body: {}) =>
    axiosApiInstance.put(url, body).then(responseBody),
  del: (url: string) => axiosApiInstance.delete(url).then(responseBody),
};

const UserAPIService = {
  getAll: (params?: any): Promise<IUserListApiResponse> =>
    requests.get("/users/getAll", params),
  generateOTP: (body: IValidateUserOTPSecurity): Promise<IOTPGenerated> =>
    requests.put("/users/generateOTP", body),
  validateOTP: (body: IValidateUserOTPSecurity): Promise<IUserSingleApiResponse> =>
    requests.put("/users/validateOTP", body),
  removeOTP: (isEmail: boolean): Promise<IUserSingleApiResponse> =>
    requests.get(`/users/removeOTP/${isEmail}` ),
  sendOTPEmail: (name: string): Promise<IAnyApiResponse> =>
    requests.get(`/auth/sendOTPEmail/${name}`),
  getById: (id: number): Promise<IUserSingleApiResponse> =>
    requests.get(`/users/getById/${id}`),
  updateOnboard: (): Promise<IUserSingleApiResponse> =>
    requests.get(`/users/updateOnboard`),
  showOnboard: (): Promise<IUserSingleApiResponse> =>
    requests.get(`/users/showOnboard`),
  create: (body: IUser): Promise<IUserSingleApiResponse> =>
    requests.post(`/users/create`, body),
  createUserIP: (body: IUserIP): Promise<IUserIPSingleApiResponse> =>
    requests.post(`/users/createUserIP`, body),
  resetPassword: (body: IResetUserPassword): Promise<IUserSingleApiResponse> =>
    axiosApiInstanceNoToken
      .put(`/users/reset-password`, body)
      .then(responseBody),
  resetPasswordAdmin: (body: IUpdateUserPassword): Promise<IUserSingleApiResponse> =>
    requests
      .put(`/users/reset-password-admin`, body),
  changePassword: (
    body: IChangeUserPassword
  ): Promise<IUserSingleApiResponse> =>
    requests.put(`/users/change-password`, body),
  validateUser: (
    body: IValidateUserAccess
  ): Promise<IUserSingleApiResponse> =>
    requests.post(`/users/validate-user`, body),
  update: (body: IUser): Promise<IUserSingleApiResponse> =>
    requests.put(`/users/update`, body),
  updateUserIP: (body: IUserIP): Promise<IUserIPSingleApiResponse> =>
    requests.put(`/users/updateUserIP`, body),
  updateJustRoles: (body: IUser): Promise<IUserSingleApiResponse> =>
    requests.put(`/users/updateJustRoles`, body),
};
export { UserAPIService };
